import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import CourseListItem from "./CourseListItem";
import { ACTION_TYPE } from "reducers/actionType";

class FilteredCourses extends Component {
  getInstName = abbr => this.props.input.institutions[abbr].name;
  handleClick = (code, abbr) => {
    const newCode = code.toString();
    const newUserCourses = Array.from(this.props.userCourses);
    if (newUserCourses.find(id => newCode === id) > -1) {
      newUserCourses.splice(newUserCourses.indexOf(newCode), 1);
    } else {
      newUserCourses.push(newCode);
    }
    this.props.dispatch({
      type: ACTION_TYPE.COURSE.PICK,
      data: newUserCourses
    });
  };

  render() {
    const {
      input,
      uniFilter,
      areaFilter,
      wordFilter = "",
      userCourses
    } = this.props;
    const { courses } = input;
    const courseList = Object.values(courses);

    const filteredCourseList = courseList.filter(course => {
      const { title, area_of_study } = course;
      const raw = wordFilter.toLowerCase().trim();
      return (
        (_.isEmpty(uniFilter) || uniFilter.includes(course.institution)) &&
        (_.isEmpty(areaFilter) || areaFilter.includes(course.primary_fos)) &&
        (!wordFilter ||
          wordFilter.length === 0 ||
          title.toLowerCase().indexOf(raw) > -1 ||
          (area_of_study && area_of_study.toLowerCase().indexOf(raw) > -1))
      );
    });

    return filteredCourseList.map((course, i) => (
      <CourseListItem
        course={course}
        key={i}
        handleClick={() =>
          this.handleClick(course.course_code, course.institution)
        }
        selected={userCourses.includes(course.course_code.toString())}
        instName={this.getInstName(course.institution)}
      />
    ));
  }
}

const mapStateToProps = store => {
  const { input } = store.inputReducer;
  const { userCourses } = store.coursesReducer;
  return { input, userCourses };
};

export default connect(mapStateToProps)(FilteredCourses);
